module.exports = __webpack_public_path__ + "img/au-aboriginal.3db8ff14.svg";